const LoadHistoryRange = {
  RANGE_LASTHOUR: 'loadhistory.range.lasthour',
  RANGE_LASTDAY: 'loadhistory.range.lastday',
  RANGE_LASTWEEK: 'loadhistory.range.lastweek',
  RANGE_LASTMONTH: 'loadhistory.range.lastmonth',
  RANGE_LAST3MONTH: 'loadhistory.range.last3month',
  RANGE_LAST6MONTH: 'loadhistory.range.last6month',
  RANGE_LASTYEAR: 'loadhistory.range.lastyear',
  RANGE_ALL: 'loadhistory.range.all'
};

export default LoadHistoryRange;